import React, { ReactElement } from "react";
import { Text, Flow } from "@xometry/xometry_loft";
import Modal from "../Common/Modal";
import { ModalStyles } from "./styles";
import { FlowContainer } from "../../opportunity/OpportunityPage/OpportunityHeaderBar/OpportunityHeaderBar.styled";

interface DeleteFileModalProps {
  modalOpen: boolean;
  isDeleting: boolean;
  setModal: (boolean) => void;
  onSubmit?: () => void;
}

const DeleteFileModal = ({
  modalOpen,
  setModal,
  onSubmit,
  isDeleting,
}: DeleteFileModalProps): ReactElement => {
  return (
    <Modal
      isOpen={modalOpen}
      selector="#modal-mount"
      title={<Text kind="panel-title">Delete This File?</Text>}
      description={
        <Text>
          Deleting a shared file permanently removes the file from this proposal
          for yourself and all other collaborators. This step cannot be undone.
        </Text>
      }
      submitActionText={
        isDeleting ? (
          <FlowContainer>
            <Flow scale="panel" kind="disabled" />
          </FlowContainer>
        ) : (
          "Delete"
        )
      }
      submitButtonType="danger"
      discardActionText="Cancel"
      handleSubmit={onSubmit}
      handleCloseButton={() => setModal(false)}
      handleCancel={() => setModal(false)}
      cssStyle={ModalStyles}
      buttonScale="large"
    />
  );
};

DeleteFileModal.defaultProps = {
  onSubmit: undefined,
};

export default DeleteFileModal;
